export default __webpack_public_path__ + "static/media/element_spec_89.a2c44312.webp";